<template>
  <v-simple-table >
    <template v-slot:default>
      <thead>
      <tr>
        <th style="text-align: center"> {{ $t("Cantidad") }} </th>
        <th style="text-align: center"> {{ $t("Código barras") }} </th>
        <th style="text-align: center"> {{ $t("Referencia") }} </th>
        <th style="text-align: center"> {{ $t("Producto") }} </th>
        <th style="text-align: center"> {{ $t("Ingresos") }} </th>
        <th style="text-align: center"> {{ $t("Costes") }} </th>
        <th style="text-align: center"> {{ $t("Beneficios") }} </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(current_producto, index) in productos" :key="index"  >
        <td style="text-align: center"> {{current_producto.cantidad}} </td>
        <td style="text-align: center"> {{ current_producto.barcode ? current_producto.barcode : '-' }} </td>
        <td style="text-align: center"> {{current_producto.referencia ? current_producto.referencia : '-'}} </td>
        <td style="text-align: center"> {{current_producto.producto}} </td>
        <td style="text-align: center"> {{current_producto.total | money}} </td>
        <td style="text-align: center"> {{current_producto.coste | money}} </td>
        <td style="text-align: center"> {{formatear_beneficio(current_producto.total, current_producto.coste) | money}} </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td style="text-align: center"> {{ $t("Total") }} </td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: center"> {{sumatorioIngresos | money}} </td>
        <td style="text-align: center"> {{sumatorioCostes | money}} </td>
        <td style="text-align: center"> {{formatear_beneficio(sumatorioIngresos, sumatorioCostes) | money}} </td>
      </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ResumenEstadisticaVentasProductos',

  props:{
    filters: {
      type: Object,
      required: true
    },
  },

  data: () => ({
    productos: [],
    sumatorioIngresos: 0,
    sumatorioCostes: 0
  }),

  methods: {
    async show_ventas_productos_resumen(){
      this.sumatorioIngresos = 0;
      this.sumatorioCostes = 0;
      const response = await this.$store.dispatch('estadisticas/get_ventas_productos_detalle', {
        centros: this.filters['centros'],
        fecha_inicio: this.filters['dates'][0],
        fecha_fin: this.filters['dates'][1],
        categorias: this.filters['categorias']
      })
      this.productos = response.results

      let arrayIngresos = response.results.map(a => a.total)
      this.sumatorioIngresos = arrayIngresos.reduce((a, b) => {
        return a + b
      }, Number(this.sumatorioIngresos)).toFixed(2)

      let arrayGastos = response.results.map(a => a.coste)
      this.sumatorioCostes = arrayGastos.reduce((a, b) => {
        return a + b
      }, Number(this.sumatorioCostes)).toFixed(2)
    },

    async show_ventas_productos_sin_impuestos_resumen(){
      this.sumatorioIngresos = 0;
      this.sumatorioCostes = 0;
      const response = await this.$store.dispatch('estadisticas/get_ventas_productos_impuestos_detalle', {
        centros: this.filters['centros'],
        fecha_inicio: this.filters['dates'][0],
        fecha_fin: this.filters['dates'][1],
        categorias: this.filters['categorias']
      })
      this.productos = response.results

      let arrayIngresos = response.results.map(a => a.total)
      this.sumatorioIngresos = arrayIngresos.reduce((a, b) => {
        return a + b
      }, Number(this.sumatorioIngresos)).toFixed(2)

      let arrayGastos = response.results.map(a => a.coste)
      this.sumatorioCostes = arrayGastos.reduce((a, b) => {
        return a + b
      }, Number(this.sumatorioCostes)).toFixed(2)
    },

    formatear_beneficio(total, coste){
      const calculo = total - coste
      return calculo.toFixed(2)
    }
  },

  computed: {
    centro(){
      return this.$store.state.centro.centro
    }
  }
}
</script>
